import { ref } from "@vue/composition-api";
import i18n from "@/libs/i18n";

export default function useChannelSettings(channelData) {
    const authenticationColumns = ref({
        bconnect: {},
        cm: {
            productToken: "",
            accountId: "",
        },
        eazy: {},
        facebook: {},
        messagebird: {
            apiKey: "",
            wabaId: "",
        },
        saysimple: {
            userId: "",
            password: "",
        },
        spryng: {
            bearer: "",
        },
        smooch: {
            keyId: "",
            secret: "",
        },
        test: {
            key: "",
        },
        twilio: {
            sid: "",
            token: "",
        },
        twitter: {},
    });
    const getSettingByName = (settingName, defaultValue = "") => {
        if (!channelData.settings) {
            channelData.settings = [];
        }

        let setting = channelData.settings.find((setting) => setting.name === settingName);
        if (!setting) {
            setting = {
                name: settingName,
                channelId: channelData.id,
                value: defaultValue,
            };
            channelData.settings.push(setting);
        }

        return setting;
    };

    const getAutoSignatureOptions = () => {
        const options = [
            {
                value: "none",
                text: i18n.t("settings.channels.automatic-signature.options.none"),
            },
            {
                value: "append-agent-name",
                text: i18n.t("settings.channels.automatic-signature.options.append-agent-name"),
            },
        ];

        const platform = channelData.platform.toLowerCase();
        if (platform === "whatsapp" || platform === "test") {
            options.push({
                value: "prepend-agent-name-bold",
                text: i18n.t("settings.channels.automatic-signature.options.prepend-agent-name-bold"),
            });
        }

        return options;
    };

    return {
        authenticationColumns,
        getSettingByName,
        getAutoSignatureOptions,
    };
}
